import styled from 'styled-components';

const CONTAINER_SIZE = 400;

export const CropContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CanvasArea = styled.div`
  position: relative;
  width: ${CONTAINER_SIZE}px;
  height: ${CONTAINER_SIZE}px;
  overflow: hidden;
  border: 2px solid #ccc;
  background: #000;
`;

export const CropImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  cursor: grab;
  transform: ${({ zoom, offset, rotation }) =>
    `translate(${offset.x}px, ${offset.y}px) scale(${zoom}) rotate(${rotation}deg)`};
  transform-origin: top left;
  user-select: none;
`;

export const CropMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${CONTAINER_SIZE}px;
  height: ${CONTAINER_SIZE}px;
  box-shadow: inset 0 0 0 2px white;
  pointer-events: none;
`;

export const ConfirmBar = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const ZoomLevel = styled.span`
  font-weight: bold;
`;

export const Controls = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const PreviewContainer = styled.div`
  margin-top: 1rem;
  border: 1px solid #ccc;
  width: 100px;
  height: 100px;
  overflow: hidden;
`;

export const PreviewBox = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
